module.exports = __webpack_public_path__ + "img/im-image-disclamimer.5aef8209.png";